function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Arrow left");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-arrow-left",
  transform: "translate(-6.000000, -6.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M17,11 L9.41,11 L12.71,7.71 C13.1021222,7.31787782 13.1021222,6.68212217 12.71,6.28999999 C12.3178778,5.89787782 11.6821222,5.89787782 11.29,6.28999999 L6.28999999,11.29 C6.19895936,11.3851037 6.12759438,11.4972487 6.07999999,11.62 C5.97998198,11.8634614 5.97998198,12.1365386 6.07999999,12.38 C6.12759438,12.5027513 6.19895936,12.6148963 6.28999999,12.71 L11.29,17.71 C11.4777666,17.8993127 11.7333625,18.0057983 12,18.0057983 C12.2666375,18.0057983 12.5222334,17.8993127 12.71,17.71 C12.8993127,17.5222334 13.0057983,17.2666375 13.0057983,17 C13.0057983,16.7333625 12.8993127,16.4777666 12.71,16.29 L9.41,13 L17,13 C17.5522848,13 18,12.5522848 18,12 C18,11.4477152 17.5522848,11 17,11 Z",
  id: "ARROW-LEFT"
})));

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left.1b404d24.svg";
export { ForwardRef as ReactComponent };